import { useMemo, useState, useEffect } from "react";
import { useTranslate, IResourceComponentsProps, useNavigation } from "@refinedev/core";
import {
    List,
    useTable,
    BooleanField,
    useEditableTable,
    SaveButton,
    EditButton,
    NumberField,
    DateField,
    useDrawerForm,
    CreateButton
} from "@refinedev/antd";

import { FormOutlined, MoreOutlined, TagOutlined, PlusOutlined } from "@ant-design/icons";
import { PageHero } from "components";
import {
    Table,
    Space,
    Form,
    Button,
    Input,
    Checkbox,
    Dropdown,
    Menu,
    Avatar,
    Grid,
    Switch,
    Spin,
    Alert
} from "antd";

import { ITag, ICustomer } from "interfaces";

import "./../../css/main.css";

export const TagList: React.FC<IResourceComponentsProps> = () => {

    const {
        tableProps,
        formProps,
        isEditing,
        saveButtonProps,
        cancelButtonProps,
        setId: setEditId,
    } = useEditableTable<ITag>({
        initialSorter: [
            {
                field: "name",
                order: "asc",
            },
        ],
    });

    const t = useTranslate();

    const TrueIcon = () => <span>✅</span>;

    const FalseIcon = () => <span>❌</span>;

    const moreMenu = (record: ITag) => (
        <Menu
            mode="vertical"
            onClick={({ domEvent }) => domEvent.stopPropagation()}
        >
            <Menu.Item
                key="accept"
                style={{
                    fontSize: 15,
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 500,
                }}
                icon={
                    <FormOutlined
                        style={{
                            color: "#52c41a",
                            fontSize: 17,
                            fontWeight: 500,
                        }}
                    />
                }
                onClick={() => {
                    setEditId?.(record.id);
                }}
            >
                {t("buttons.edit")}
            </Menu.Item>
        </Menu>
    );

    const rowClassName = (record : any) => {
        return record.active ? '' : 'row-disabled';
    };

    const breakpoint = Grid.useBreakpoint();

    const totalTags = tableProps?.dataSource?.length ?? 0;
    const activeTags = tableProps?.dataSource?.filter((g: any) => g.active).length ?? 0;

    return (
        <>
        <PageHero
            eyebrow="Atalhos"
            title="Grupos de recebedores"
            subtitle="Crie grupos favoritos para reutilizar a mesma combinação de recebedores nas cobranças."
            icon={<TagOutlined />}
            tone="pink"
            stats={[
                { label: "Total", value: totalTags },
                { label: "Ativos", value: activeTags },
            ]}
            actions={<CreateButton type="primary" icon={<PlusOutlined />}>Criar Grupo</CreateButton>}
        />
        <div className="card-table-wrap">
            <Form {...formProps}>
                <Table
                    {...tableProps}
                    expandable={{
                        expandedRowRender: !breakpoint.xs ? expandedRowRender : undefined,
                    }}
                    rowKey="id"
                    onRow={(record) => ({
                        // eslint-disable-next-line
                        onClick: (event: any) => {
                            if (event.target.nodeName === "TD") {
                                setEditId && setEditId(record.id);
                            }
                        },
                    })}
                    rowClassName={rowClassName}
                >
                    <Table.Column
                        key="name"
                        dataIndex="name"
                        title="Grupo"
                        render={(value, data: ITag) => {
                            if (isEditing(data.id)) {
                                return (
                                    <Form.Item
                                        name="name"
                                        style={{ margin: 0 }}
                                    >
                                        <Input />
                                    </Form.Item>
                                );
                            }
                            const tones = ["pink", "violet", "blue", "teal", "amber", "green"];
                            const tone = tones[(data.id || 0) % tones.length];
                            return (
                                <div className="cell-with-avatar">
                                    <span className={`pill pill-${tone}`} style={{ padding: "0.35rem 0.55rem" }}><TagOutlined /></span>
                                    <span style={{ fontWeight: 600, color: "var(--text-primary)" }}>{value}</span>
                                </div>
                            );
                        }}
                    />
                    <Table.Column
                        key="customers"
                        dataIndex="customers"
                        title="Clientes"
                        render={(v) => <span className="pill pill-slate">{v ?? 0}</span>}
                    />
                    <Table.Column
                        key="active"
                        dataIndex="active"
                        title="Status"
                        render={(value, data: ITag) => {
                            if (isEditing(data.id)) {
                                return (
                                    <Form.Item
                                        name="active"
                                        style={{ margin: 0 }}
                                        valuePropName="checked"
                                    >
                                        <Switch checkedChildren="SIM" unCheckedChildren="NÃO"/>
                                    </Form.Item>
                                );
                            }
                            return <span className={`pill ${value ? "pill-green" : "pill-red"}`}>{value ? "Ativo" : "Inativo"}</span>;
                            // return <Switch onClick={() => { setEditId(data.id); }} disabled={true} checked={value} style={{ 'pointerEvents': 'none'}} checkedChildren="SIM" unCheckedChildren="NÃO"/>;
                            // return <BooleanField
                            // trueIcon={<TrueIcon />}
                            // falseIcon={<FalseIcon />}
                            // value={value} />;
                        }}
                    />
                    <Table.Column<ITag>
                        title={"Editar"}
                        dataIndex="actions"
                        key="actions"
                        align="center"
                        render={(_text, record) => {
                            if (isEditing(record.id)) {
                                return (
                                    <Space>
                                        <SaveButton
                                            {...saveButtonProps}
                                            size="small"
                                        />
                                        <Button
                                            {...cancelButtonProps}
                                            size="small"
                                        >
                                            {t("buttons.cancel")}
                                        </Button>
                                    </Space>
                                );
                            }
                            return (
                                // <Dropdown
                                //     overlay={moreMenu(record)}
                                //     trigger={["click"]}
                                // >
                                //     <MoreOutlined
                                //         onClick={(e) => e.stopPropagation()}
                                //         style={{
                                //             fontSize: 24,
                                //         }}
                                //     />
                                // </Dropdown>                                
                                <EditButton
                                    hideText
                                    size="large"
                                    recordItemId={record.id}
                                    onClick={() => {
                                        setEditId?.(record.id);
                                    }}
                                />
                            );
                        }}
                    />
                </Table>
            </Form>
        </div>
        <Alert
            message={`Clique no botão ➕ para expandir e selecionar os clientes`}
            type="info"
            showIcon
            style={{marginTop: 15}}
        />
        <Alert
            message={`Crie grupos de recebedores favoritos e utilize-os ao criar uma cobrança`}
            type="success"
            showIcon
            style={{marginTop: 15}}
        />
        </>
    );
};

const TagCustomersTable: React.FC<{ record: ITag }> = ({ record }) => {    
    
    const t = useTranslate();
    const { edit, show } = useNavigation();
    const [loading, setLoading] = useState(false);
    const tagId = record.id;
    console.log(record);

    const { tableProps: postTableProps,
            // tableProps,
            formProps,
            isEditing,
            saveButtonProps,
            cancelButtonProps,
            setId: setEditId,
        } = useEditableTable<ICustomer>({
        resource: "customerTags",
        pagination: {
            pageSize: 10,
        },
        permanentFilter: [
            {
                field: "tagId",
                operator: "eq",
                value: record.id,
            },
        ],
        syncWithLocation: false,
    });

    const TrueIcon = () => <span>✅</span>;

    const FalseIcon = () => <span>❌</span>;

    const loader = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 3000);            
    };

    const rowClassName = (record : any) => {
        return record.tagActive ? '' : 'row-disabled';
    };

    return (
        <List title={`${t("customers.customers")} - ${record.name}`}
            headerButtons={({ defaultButtons }) => (
            <></>
          )}>
            {(!record.active) && (<Alert
                message={`Atenção: este grupo está inativo, clique no botão "Editar" para ativá-lo e ficar disponível nas cobranças`}
                type="error"
                showIcon
                style={{margin: "15px 0px"}}
            />)}
            <Form
                {...formProps}
                // initialValues={{ tagId }}
            >
                <Table {...postTableProps}
                    rowKey="id"
                    onRow={(record) => ({
                        // eslint-disable-next-line
                        onClick: (event: any) => {
                            if (event.target.nodeName === "TD") {
                                setEditId && setEditId(`${record.id}-${tagId}`);
                            }
                        },
                    })}
                    rowClassName={rowClassName}
                >
                    <Table.Column
                        key="name"
                        dataIndex="name"
                        title={t("customers.fields.name")}
                    />
                    {/* <Table.Column
                        key="payerOrReceiverText"
                        dataIndex="payerOrReceiverText"
                        title={t("customers.fields.payerOrReceiver.title")}
                    /> */}
                    <Table.Column
                        key="tagActive"
                        dataIndex="tagActive"
                        title={t("customers.fields.tagActive.title")}                                
                        render={(value, data: ICustomer) => {                                    
                            if (isEditing(`${data.id}-${tagId}`)) {
                                return (<>
                                    <Button {...saveButtonProps} style={{ padding: 0, border: 'none', background: 'transparent' }}>                                    
                                    <Form.Item
                                        name="tagActive"                                                
                                        valuePropName="checked"
                                    >
                                        {(loading) && (<Spin spinning={loading}/>)}
                                        <Switch checkedChildren="SIM" unCheckedChildren="NÃO" onChange={loader}/>
                                    </Form.Item>
                                    </Button>
                                </>);
                            }
                            return <Switch onClick={() => { loader(); }} checked={value} disabled={true} style={{ 'pointerEvents': 'none'}} checkedChildren="SIM" unCheckedChildren="NÃO"/>
                        }}
                    />                
                    <Table.Column<ICustomer>
                        title="Editar"
                        dataIndex="actions"
                        render={(_, record) => (
                            <Space>
                                <EditButton
                                    hideText
                                    size="large"
                                    recordItemId={record.id}
                                    onClick={() => edit("customers", record?.id)}
                                />
                            </Space>
                        )}
                    />
                </Table>
            </Form>
        </List>
    );
};

const expandedRowRender = (record: ITag) => {
    return <TagCustomersTable record={record} />;
};
